import { RadioButtonWithLabelGroupWidget, RadioButtonWithLabelOption } from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { useFormikContext } from '../../../../FormikWrapperForStubbing';
import { settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { useSharedWidgetChangeHandler } from '../../../utils';
import { SiteInfo, SiteSettingsForServerAdminProps } from '../../ReactSiteSettingsForServerAdmin';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { ManageUsersAdminOption } from './ManageUsersAdminsOption';

export const MANAGE_USERS_FIELD = 'settings.siteAdminsCanAddUsers';
export type ManageUsersSectionProps = SiteSettingsForServerAdminProps<
  'siteAdminsCanAddUsers'
  | 'userQuotaMode'
  | 'userQuota'
  | 'tierCreatorCapacity'
  | 'tierExplorerCapacity'
  | 'tierViewerCapacity'
  >
  & SiteInfo

function getButtonsList(props: ManageUsersSectionProps): RadioButtonWithLabelOption<boolean>[] {
  return [
    {
      value: false,
      label: Messages.onlyServerAdmins(),
      testId: 'only-system-admins-radio-button'
    },
    {
      value: true,
      label: <ManageUsersAdminOption {...props}/>,
      testId: 'system-and-site-admins-radio-button'
    }
  ];
}

export function ManageUsersSection(props: ManageUsersSectionProps) {
  const formik = useFormikContext<ManageUsersSectionProps>();

  const buttons = React.useMemo(() => getButtonsList(props), [props]);

  const index = buttons.findIndex(button => button.value === formik.values.settings.siteAdminsCanAddUsers);

  const handleChange = useSharedWidgetChangeHandler(MANAGE_USERS_FIELD);

  return <SettingsSection title={Messages.managingUsers()}
                          description={Messages.managingUsersDetails()}>

    <RadioButtonWithLabelGroupWidget buttonList={buttons}
                                     aria-label={Messages.managingUsersDetails()}
                                     className={settingsRadioButtonItemHeight}
                                     checkedIndex={index}
                                     handleChange={handleChange}/>
  </SettingsSection>;
}

export const ManageUsersSectionSpecs = componentRegistryEntry({
  name: 'ManageUsersSection',
  component: ManageUsersSection
});
